import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _EmployeeContract } from '../../../../../../core/services/dataBean/EntityCatalog';
import Select from 'react-select';
import { toast } from 'react-toastify';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const ContributorSubTypeEditor = ({ idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_EmployeeContract)
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, [])

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDContributorSubtype === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDContributorSubtype,
                    label: `${found.DataBeanProperties.Name}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);


    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(null);
        } else {

            if (onChange) {
                onChange(option.value);
            }
        }
    };

    const getLista = () => {

        instance.getContributorSubtypeCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(e => { toast.error(e) })

    }

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDContributorSubtype,
        label: `${item.DataBeanProperties.Name}`,
        item: item
    }));

    return (
        <div>
            {label && label != " " ?
                < label > {label ?? "Subtipo de Cotizante"}</label>
                :
                <label>SubTipo de Cotizante</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder={`Selecciona un subtipo de Cotizante...`}
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
}